import { useState } from 'react';
import { Container, Card, Form, Row, Col, Button, Spinner, Badge } from 'react-bootstrap';
import { FaPenFancy, FaCopy, FaDownload, FaRedo, FaClipboard } from 'react-icons/fa';
import { FiAward, FiFeather, FiSend, FiTarget } from 'react-icons/fi';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// TODO: এখানে আপনার নিজের backend সার্ভারের URL বসান
const API_ENDPOINT = ' https://img.hrlimon.com//api/thread-maker';

const brand = {
  navy: '#041442',
  orange: '#ff9a3e',
  red: '#ff5266',
};

export default function ThreadMaker() {
  const [title, setTitle] = useState('');
  const [tone, setTone] = useState('Informational');
  const [language, setLanguage] = useState('Bangla');
  const [postCount, setPostCount] = useState('5-7');
  const [loading, setLoading] = useState(false);
  const [hook, setHook] = useState('');
  const [threadPosts, setThreadPosts] = useState([]);
  const [cta, setCta] = useState('');
  const [bonus, setBonus] = useState('');
  const [signature, setSignature] = useState('');
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [copiedAll, setCopiedAll] = useState(false);

  // Bengali Example Prompts
  const examplePrompts = [
    'ফ্রিল্যান্সিং শুরু করার ৭টি টিপস',
    'ChatGPT দিয়ে কনটেন্ট লেখার সহজ উপায়',
    'AI টুলস দিয়ে আয় করার কৌশল',
  ];

  const generateThread = async () => {
    if (!title.trim()) {
      alert('Please enter a topic or title');
      return;
    }

    setLoading(true);
    setHook('');
    setThreadPosts([]);
    setCta('');
    setBonus('');
    setSignature('');
    setCopiedIndex(null);
    setCopiedAll(false);

    try {
      const res = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title,
          tone,
          language,
          postCount,
        }),
      });

      const data = await res.json();

      if (data.error) {
        setThreadPosts([{ content: 'Error: ' + data.error, isError: true }]);
      } else {
        // Parse thread into hook, posts, CTA, bonus, and signature
        const parsed = parseThread(data.thread);
        setHook(parsed.hook);
        setThreadPosts(parsed.posts);
        setCta(parsed.cta);
        setBonus(parsed.bonus);
        setSignature(parsed.signature);
      }
    } catch (error) {
      setThreadPosts([{ content: 'Something went wrong. Please check your backend server.', isError: true }]);
    }

    setLoading(false);
  };

  // Parse thread content into hook, posts, CTA, bonus, and signature
  const parseThread = (thread) => {
    const lines = thread.split('\n');
    let hookLine = '';
    const posts = [];
    let ctaLine = '';
    let bonusLine = '';
    let signatureLine = '';

    const emojiNumbers = ['1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟'];

    lines.forEach((line) => {
      const trimmed = line.trim();

      // Skip empty lines
      if (!trimmed) return;

      // Check if it's the signature line
      if (trimmed.includes('এমন আরও নতুন আপডেট') || trimmed.includes('Habibur Rahman')) {
        signatureLine = trimmed;
      }
      // Check if it's a bonus line
      else if (trimmed.includes('🔥') && (trimmed.includes('Bonus') || trimmed.includes('বোনাস'))) {
        bonusLine = trimmed;
      }
      // Check if it's a numbered post with emoji numbers
      else if (emojiNumbers.some((emoji) => trimmed.startsWith(emoji))) {
        const cleanLine = trimmed.replace(/^[1-9️⃣🔟]+\s*/, '').trim();
        if (cleanLine) {
          posts.push({ content: cleanLine, isError: false });
        }
      }
      // Check if it looks like a CTA
      else if (
        (trimmed.includes('🎯') || trimmed.includes('💡') || trimmed.includes('🔔') ||
          trimmed.includes('মতামত') || trimmed.includes('কমেন্ট') || trimmed.includes('শেয়ার')) &&
        !hookLine &&
        posts.length > 0
      ) {
        ctaLine = trimmed;
      }
      // Otherwise, if we don't have a hook yet, this is the hook
      else if (!hookLine && posts.length === 0 && !ctaLine) {
        hookLine = trimmed;
      }
    });

    return {
      hook: hookLine,
      posts,
      cta: ctaLine,
      bonus: bonusLine,
      signature: signatureLine,
    };
  };

  const getEmojiNumber = (index) => {
    const emojiNumbers = ['1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟'];
    return emojiNumbers[index] || `${index + 1}️⃣`;
  };

  const copyToClipboard = (text, index = null) => {
    navigator.clipboard.writeText(text);
    if (index !== null) {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    }
  };

  const copyAllContent = () => {
    let allText = '';

    if (hook) allText += hook + '\n\n';

    allText += threadPosts.map((post, i) => `${getEmojiNumber(i)} ${post.content}`).join('\n\n');

    if (cta) allText += '\n\n' + cta;
    if (bonus) allText += '\n\n' + bonus;
    if (signature) allText += '\n\n' + signature;

    navigator.clipboard.writeText(allText);
    setCopiedAll(true);
    setTimeout(() => setCopiedAll(false), 2000);
  };

  const downloadAsText = () => {
    let allText = '';

    if (hook) allText += hook + '\n\n';

    allText += threadPosts.map((post, i) => `${getEmojiNumber(i)} ${post.content}`).join('\n\n');

    if (cta) allText += '\n\n' + cta;
    if (bonus) allText += '\n\n' + bonus;
    if (signature) allText += '\n\n' + signature;

    const blob = new Blob([allText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'thread.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  const resetForm = () => {
    setTitle('');
    setTone('Informational');
    setLanguage('Bangla');
    setPostCount('5-7');
    setHook('');
    setThreadPosts([]);
    setCta('');
    setBonus('');
    setSignature('');
    setCopiedIndex(null);
    setCopiedAll(false);
  };

  const fillExample = (example) => {
    setTitle(example);
  };

  return (
    <div className="bg-white position-relative overflow-hidden rounded-4">
      {/* Glow Effects */}
      <div
        className="position-absolute top-0 start-0 rounded-circle"
        style={{ width: 384, height: 384, backgroundColor: brand.red, opacity: 0.2, filter: 'blur(150px)', pointerEvents: 'none' }}
      ></div>
      <div
        className="position-absolute bottom-0 end-0 rounded-circle"
        style={{ width: 384, height: 384, backgroundColor: brand.orange, opacity: 0.2, filter: 'blur(150px)', pointerEvents: 'none' }}
      ></div>

      {/* Main Container */}
      <div >
        {/* Input Section */}
        <Card className="shadow-lg border-0 p-4">
          <Card.Body>
            <Form.Label className="fw-semibold fs-5" style={{ color: brand.navy }}>
              Enter Your Topic or Context
            </Form.Label>

            <Form.Control
              as="textarea"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Example: ফ্রিল্যান্সিং শুরু করার ৭টি টিপস..."
              rows={4}
              className="mb-4"
              style={{ resize: 'none' }}
            />

            {/* Example Prompts */}
            <div className="mb-4">
              <p className="small text-secondary mb-2">Quick Examples (Click to use):</p>
              <Row className="g-2">
                {examplePrompts.map((example, index) => (
                  <Col md={4} key={index}>
                    <Button
                      variant="light"
                      onClick={() => fillExample(example)}
                      className="w-100 text-start small border"
                    >
                      {example}
                    </Button>
                  </Col>
                ))}
              </Row>
            </div>

            {/* Options Row */}
            <Row className="g-3 mb-4">
              <Col md={4}>
                <Form.Label className="fw-medium small">Tone</Form.Label>
                <Form.Select value={tone} onChange={(e) => setTone(e.target.value)}>
                  <option value="Informational">Informational</option>
                  <option value="Casual">Casual</option>
                  <option value="Professional">Professional</option>
                  <option value="Humorous">Humorous</option>
                  <option value="Inspirational">Inspirational</option>
                </Form.Select>
              </Col>

              <Col md={4}>
                <Form.Label className="fw-medium small">Language</Form.Label>
                <Form.Select value={language} onChange={(e) => setLanguage(e.target.value)}>
                  <option value="English">English</option>
                  <option value="Bangla">Bangla</option>
                </Form.Select>
              </Col>

              <Col md={4}>
                <Form.Label className="fw-medium small"># of Posts</Form.Label>
                <Form.Select value={postCount} onChange={(e) => setPostCount(e.target.value)}>
                  <option value="3-5">3-5 Posts</option>
                  <option value="5-7">5-7 Posts</option>
                  <option value="7-10">7-10 Posts</option>
                  <option value="10-15">10-15 Posts</option>
                </Form.Select>
              </Col>
            </Row>

            <Button
              onClick={generateThread}
              disabled={loading}
              className="w-100 py-3 fw-bold border-0"
              style={{
                background: `linear-gradient(to right, ${brand.red}, ${brand.orange})`,
                color: '#fff',
                fontSize: '1.05rem',
              }}
            >
              {loading ? (
                <span className="d-flex align-items-center justify-content-center gap-2">
                  <Spinner animation="border" size="sm" /> Generating Thread...
                </span>
              ) : (
                <span className="d-flex align-items-center justify-content-center gap-2">
                  <FaPenFancy /> Generate Thread
                </span>
              )}
            </Button>
          </Card.Body>
        </Card>

        {/* Output Section */}
        {(hook || threadPosts.length > 0) && (
          <Card className="shadow-lg border-0 p-4 mt-4">
            <Card.Body>
              <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
                <h2 className="fw-bold fs-3" style={{ color: brand.navy }}>
                  Your Thread
                </h2>

                <div className="d-flex gap-2">
                  <Button
                    onClick={copyAllContent}
                    className="d-flex align-items-center gap-2 border-0 fw-medium"
                    style={{ background: `linear-gradient(to right, ${brand.red}, ${brand.orange})`, color: '#fff' }}
                  >
                    <FaClipboard /> {copiedAll ? 'All Copied!' : 'Copy All'}
                  </Button>

                  <Button variant="dark" onClick={downloadAsText} className="d-flex align-items-center gap-2 fw-medium">
                    <FaDownload /> Download
                  </Button>

                  <Button
                    variant="outline-danger"
                    onClick={resetForm}
                    className="d-flex align-items-center gap-2 fw-medium"
                  >
                    <FaRedo /> Reset
                  </Button>
                </div>
              </div>

              <div className="d-flex flex-column gap-3">
                {/* Hook Post */}
                {hook && (
                  <div
                    className="p-4 rounded-3 text-white shadow"
                    style={{ background: 'linear-gradient(to right, #ec4899, #9333ea)' }}
                  >
                    <div className="d-flex align-items-start justify-content-between gap-3">
                      <div className="flex-grow-1">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <FiFeather size={22} />
                          <span className="fw-bold fs-5">Hook Post</span>
                        </div>
                        <p className="mb-0 fs-5 fw-medium">{hook}</p>
                      </div>
                      <Button
                        variant="light"
                        size="sm"
                        onClick={() => copyToClipboard(hook, 'hook')}
                        className="flex-shrink-0 fw-medium d-flex align-items-center gap-2"
                        style={{ color: '#9333ea' }}
                      >
                        <FaCopy /> {copiedIndex === 'hook' ? 'Copied!' : 'Copy'}
                      </Button>
                    </div>
                  </div>
                )}

                {/* Thread Posts */}
                {threadPosts.map((post, index) => (
                  <div
                    key={index}
                    className="p-4 rounded-3 shadow-sm"
                    style={{
                      background: 'linear-gradient(to right, #f9fafb, #ffffff)',
                      borderLeft: `4px solid ${brand.red}`,
                    }}
                  >
                    <div className="d-flex align-items-start justify-content-between gap-3">
                      <div className="flex-grow-1">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <span className="fs-3">{getEmojiNumber(index)}</span>
                          <Badge bg="light" text="secondary" className="fw-normal">
                            Post {index + 1} of {threadPosts.length}
                          </Badge>
                        </div>
                        <p className="mb-0" style={{ color: '#1f2937' }}>
                          {post.content}
                        </p>
                      </div>

                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => copyToClipboard(`${getEmojiNumber(index)} ${post.content}`, index)}
                        className="flex-shrink-0 fw-medium d-flex align-items-center gap-2"
                      >
                        <FaCopy /> {copiedIndex === index ? 'Copied!' : 'Copy'}
                      </Button>
                    </div>
                  </div>
                ))}

                {/* CTA Card */}
                {cta && (
                  <div
                    className="p-4 rounded-3 text-white shadow"
                    style={{ background: 'linear-gradient(to right, #3b82f6, #06b6d4)' }}
                  >
                    <div className="d-flex align-items-start justify-content-between gap-3">
                      <div className="flex-grow-1">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <FiTarget size={18} />
                          <span className="fw-semibold">Call to Action</span>
                        </div>
                        <p className="mb-0">{cta}</p>
                      </div>
                      <Button
                        variant="light"
                        size="sm"
                        onClick={() => copyToClipboard(cta, 'cta')}
                        className="flex-shrink-0 fw-medium d-flex align-items-center gap-2"
                        style={{ color: '#2563eb' }}
                      >
                        <FaCopy /> {copiedIndex === 'cta' ? 'Copied!' : 'Copy'}
                      </Button>
                    </div>
                  </div>
                )}

                {/* Bonus Card */}
                {bonus && (
                  <div
                    className="p-4 rounded-3 text-white shadow"
                    style={{ background: 'linear-gradient(to right, #f97316, #ef4444)' }}
                  >
                    <div className="d-flex align-items-start justify-content-between gap-3">
                      <div className="flex-grow-1">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <FiAward size={18} />
                          <span className="fw-semibold">Bonus Tips</span>
                        </div>
                        <p className="mb-0">{bonus}</p>
                      </div>
                      <Button
                        variant="light"
                        size="sm"
                        onClick={() => copyToClipboard(bonus, 'bonus')}
                        className="flex-shrink-0 fw-medium d-flex align-items-center gap-2"
                        style={{ color: '#ea580c' }}
                      >
                        <FaCopy /> {copiedIndex === 'bonus' ? 'Copied!' : 'Copy'}
                      </Button>
                    </div>
                  </div>
                )}

                {/* Signature Card */}
                {signature && (
                  <div
                    className="p-4 rounded-3 text-white shadow"
                    style={{ background: `linear-gradient(to right, ${brand.red}, ${brand.orange})` }}
                  >
                    <div className="d-flex align-items-start justify-content-between gap-3">
                      <div className="flex-grow-1">
                        <div className="d-flex align-items-center gap-2 mb-2">
                          <FiSend size={18} />
                          <span className="fw-semibold">Author Signature</span>
                        </div>
                        <p className="mb-0 fst-italic">{signature}</p>
                      </div>
                      <Button
                        variant="light"
                        size="sm"
                        onClick={() => copyToClipboard(signature, 'signature')}
                        className="flex-shrink-0 fw-medium d-flex align-items-center gap-2"
                        style={{ color: brand.red }}
                      >
                        <FaCopy /> {copiedIndex === 'signature' ? 'Copied!' : 'Copy'}
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Card.Body>
          </Card>
        )}
      </div>
    </div>
  );
}